module.exports = __webpack_public_path__ + "img/ico_input_insta.8e95fa1.png";